import { useEffect } from 'react'
import { useSetRecoilState } from 'recoil'
import eventBus from '../../../../services/eventBus'
import recoilStateUpdaters from '../../../../recoil/recoil.stateUpdaters.ts'
import maintenanceBlankSchemasAtom from '../MaintenanceBlanks/maintenanceBlankSchemas.atom.ts'
import maintenanceProcessesAtom from '../MaintenanceProcesses/maintenanceProcesses.atom.ts'

const useMaintenanceEventsSubscriptions = () => {
  const setState = useSetRecoilState(maintenanceBlankSchemasAtom)
  const setProcessesState = useSetRecoilState(maintenanceProcessesAtom)

  useEffect(() => {
    const createSub = eventBus.sub('maintenance.schemas.created', (item) => {
      recoilStateUpdaters.itemCreated(setState, item)
    })

    const updateSub = eventBus.sub('maintenance.schemas.updated', (item) => {
      recoilStateUpdaters.itemUpdated(setState, item)
    })

    const removeSub = eventBus.sub('maintenance.schemas.deleted', (id) => {
      recoilStateUpdaters.itemDeleted(setState, id)
    })

    const createProcessSub = eventBus.sub('maintenance.processes.created', (item) => {
      recoilStateUpdaters.itemCreated(setProcessesState, item)
    })

    const updateProcessSub = eventBus.sub('maintenance.processes.updated', (item) => {
      recoilStateUpdaters.itemUpdated(setProcessesState, item)
    })

    const removeProcessSub = eventBus.sub('maintenance.processes.deleted', (id) => {
      recoilStateUpdaters.itemDeleted(setProcessesState, id)
    })

    return () => {
      createSub()
      updateSub()
      removeSub()

      createProcessSub()
      updateProcessSub()
      removeProcessSub()
    }
  }, [])
}

export default useMaintenanceEventsSubscriptions
